import { CrudOp, geometryAuthScope, targetAuthScope, tmmAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { DocManagerIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { GeometryManagerView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand, project }) => {
  const authHelperGeometry = authHelperCreator(geometryAuthScope);
  const authHelperTarget = authHelperCreator(targetAuthScope);
  const authHelperTmm = authHelperCreator(tmmAuthScope);
  return brand != null && authHelperGeometry.evaluate(CrudOp.READ, brand)
    && authHelperTarget.evaluate(CrudOp.READ)
    && project != null && authHelperTmm.evaluate(CrudOp.READ, project);
};

export const geometryManagerViewKey = "geometry_modular_geometry/:brand/:tmmId/manager";
export const geometryManagerViewModule: ViewModule = {
  viewKey: geometryManagerViewKey,
  viewEl: <GeometryManagerView/>,
  displayNameI18nKey: "documentManager:viewName",
  menuIconEl: <DocManagerIcon/>,
  isAuthorized,
  translations,
};
